import React, { Component } from "react";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import { Carousel } from 'react-responsive-carousel';
import db from "../../constants/database";

export default class TestimonialTalent extends Component {
    render() {
        return (
            <section className=' bg-[black] w-[100%] h-[100%] mb:h-[100%] px-3 md:px-14 font-abel text-center md:flex md:justify-center md:items-center'>
                <div className='testimonial-content pb-5 pt-16'>
                    <p className='text-[28px] md:text-[40px] md:text-center text-left font-[400] md:mt-10 text-[#ffffff] mb-4'>Talents' Testimonials</p>
                    {/* <div className="border-l-2 border-[white] md:block hidden absolute ml-[100px] z-10"></div> */}
                    <Carousel
                        showArrows={true}
                        infiniteLoop={true}
                        showThumbs={false}
                        showStatus={false}
                        autoPlay={true}
                        interval={6100}>
                        {db.testimoniesTalent?.map((item) =>
                            <div key={item.id}>
                                <p className='text-[16px] md:text-[16px] md:mb-4 max-w-[552px] m-auto text-[#ffffff] text-left'>{item.content}</p>
                                <div className="testimony-name-img flex justify-between align-middle w-full h-full max-w-[552px] m-auto mt-4">
                                    <p className='mb-5 text-[16px] md:text-[16px] md:mb-10 text-[#B3B3B3] text-left max-w-[360px]'>{item.name}</p>
                                    <div className="md:w-[100px] w-[50px]">
                                        <img src={item.path} alt="testimonial" className="md:w-[90px] w-[50px]" />
                                    </div>
                                </div>
                            </div>
                        )}
                    </Carousel>
                    <div className="max-w-[780px] ml-auto">
                        <a href="https://www.google.com/search?q=25th+and+staffing&rlz=1C5CHFA_enNG1008NG1008&oq=25t&aqs=chrome.0.69i59j46i39i175i199i650j69i57j0i67i650l2j46i512j0i512l3j46i512.3144j0j15&sourceid=chrome&ie=UTF-8#" target="_blank" rel="noreferrer" className="text-[#FFFFFF] hover:text-[#CDD8FE] underline text-[16px] text-right font-abel">See more reviews on google</a>
                    </div>
                </div>
            </section>
        );
    }
}